import { apiClient } from '../../gateways/api'

export { resetAanvraag }

const resetAanvraag = async ({ aanvraagID }: { aanvraagID: string }) => {
  await apiClient({
    url: `/rest/beheer/aanvraag/${aanvraagID}/reset`,
    method: 'POST',
  })
}
